import { render, staticRenderFns } from "./customimg.vue?vue&type=template&id=05a489e2&scoped=true&"
import script from "./customimg.vue?vue&type=script&lang=js&"
export * from "./customimg.vue?vue&type=script&lang=js&"
import style0 from "./customimg.vue?vue&type=style&index=0&id=05a489e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a489e2",
  null
  
)

export default component.exports